import { TagThumbnail } from '@/components/ui/tag-thumbnail'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { formatPrice } from '@/lib/utils'
import Image from 'next/image'
import Link from 'next/link'
import { ProductInfoSuggestModal } from './product-info-suggest-modal'

// Use generic product type that works with both detailed and summary products
interface ProductProps {
  product: {
    id: string
    display_name: string
    seo_alias: string
    regular_price: number
    compare_price?: number
    percent?: number
    default_thumbnail: string
    [key: string]: unknown
  }
}

export const ProductInfoSuggestItem = ({ product }: ProductProps) => {
  return (
    <figure className='flex h-full flex-col gap-2' title={product.display_name}>
      <picture className='group flex-1 overflow-hidden rounded-md'>
        <Link
          href={`/product/${product.seo_alias}`}
          className='block h-full'
          data-tracking-level-3={'ViewDetail'}
          data-ga-tracking-label={product.seo_alias}
        >
          <Image
            src={ImageHelper.getImageUrl(product.default_thumbnail)}
            alt={product.display_name}
            width={145}
            height={195}
            className='h-full w-auto object-cover transition-all duration-300 group-hover:scale-105'
          />
        </Link>
      </picture>
      <figcaption className='flex flex-col gap-1'>
        <Link
          href={`/product/${product.seo_alias}`}
          data-tracking-level-3={'ViewDetail'}
          className='line-clamp-1 font-sans text-sm leading-5 text-neutral-600 hover:text-primary-500'
        >
          {product.display_name}
        </Link>

        <div className='lg:flex lg:items-center lg:justify-between'>
          <div>
            <div className='flex items-center'>
              <p className='line-clamp-1 font-sans text-sm font-bold leading-4.5 text-neutral-900 lg:text-base lg:leading-5'>
                {formatPrice(product.regular_price)}
              </p>
              {product.percent && product.percent > 0 ? (
                <TagThumbnail
                  title={`-${product.percent}%`}
                  className='ml-1 h-4 px-1'
                  size='small'
                  variant='neutral'
                />
              ) : null}
            </div>
            {product.regular_price > (product.compare_price || 0) &&
              product.compare_price &&
              product.compare_price > 0 && (
                <del className='block text-xs text-neutral-800/70 lg:text-sm lg:leading-4.5'>
                  {formatPrice(product.compare_price)}
                </del>
              )}
          </div>
          <ProductInfoSuggestModal product={product} />
        </div>
      </figcaption>
    </figure>
  )
}
